import ReactAutosuggest from './react-autosuggest';

export default ReactAutosuggest;
